import {Tabs} from 'antd';
import styled from 'styled-components';
import {typographyStyles} from '../../utils/styles';

const tabPaddingBySize = {
  middle: '9px 16px',
  large: '9px 32px'
};
const getTabPadding = props => tabPaddingBySize[props.$tabPaddingSize] || tabPaddingBySize.large;

const StyledTabs = styled(Tabs)`
  width: 100%;

  &:not(.ant-tabs-card) {
    .ant-tabs-tab {
      ${typographyStyles.body.medium};
      padding: ${getTabPadding};

      & + .ant-tabs-tab {
        margin-left: 0;
      }
    }
  }

  &.ant-tabs-card {
    .ant-tabs-nav {
      margin-bottom: 0;

      &::before {
        border-bottom-color: ${props => props.theme.colors.neutral_3};
      }

      .ant-tabs-tab {
        font-weight: 500;
        padding: ${getTabPadding};

        &.ant-tabs-tab-active {
          background-color: ${props => props.theme.colors.neutral_1};
          border-color: ${props => props.theme.colors.neutral_3};
          border-bottom-color: ${props => props.theme.colors.neutral_1};
        }

        &:not(.ant-tabs-tab-active) {
          background: unset;
          border-color: transparent;
        }
      }
    }

    .ant-tabs-content-holder {
      background-color: ${props => props.theme.colors.neutral_1};
      border: 1px solid ${props => props.theme.colors.neutral_3};
      border-top: unset;
    }
  }
`;


export {
  StyledTabs
};
